/**
 * Menu JavaScript
 * Handles hamburger menu open/close functionality
 */

(function() {
  'use strict';

  let menuOpen = false;
  let menu = null;
  let toggleBtn = null;
  let closeBtn = null;

  /**
   * Initialize menu functionality
   */
  function init() {
    menu = document.querySelector('[data-hamburger-menu]');
    toggleBtn = document.querySelector('[data-hamburger-toggle]');
    closeBtn = document.querySelector('[data-hamburger-close]');

    if (!menu) return;

    // Bind events
    if (toggleBtn) {
      toggleBtn.addEventListener('click', openMenu);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', closeMenu);
    }

    // Close on escape key
    document.addEventListener('keydown', handleKeyDown);

    // Close when clicking outside menu content
    menu.addEventListener('click', handleBackdropClick);

    // Close menu on SPA navigation
    document.addEventListener('click', handleLinkClick);
  }

  /**
   * Open the menu
   */
  function openMenu() {
    if (!menu) return;

    menuOpen = true;
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');

    if (toggleBtn) {
      toggleBtn.setAttribute('aria-expanded', 'true');
    }

    // Prevent body scroll
    document.body.style.overflow = 'hidden';

    // Focus first menu link
    const firstLink = menu.querySelector('.hamburger-menu__link');
    if (firstLink) {
      setTimeout(() => firstLink.focus(), 100);
    }
  }

  /**
   * Close the menu
   */
  function closeMenu() {
    if (!menu) return;

    menuOpen = false;
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');

    if (toggleBtn) {
      toggleBtn.setAttribute('aria-expanded', 'false');
      toggleBtn.focus();
    }

    // Restore body scroll
    document.body.style.overflow = '';
  }

  /**
   * Toggle menu state
   */
  function toggleMenu() {
    if (menuOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  /**
   * Handle keyboard events
   */
  function handleKeyDown(e) {
    if (!menuOpen) return;

    if (e.key === 'Escape') {
      closeMenu();
    }

    // Trap focus within menu
    if (e.key === 'Tab') {
      trapFocus(e);
    }
  }

  /**
   * Trap focus within menu
   */
  function trapFocus(e) {
    const focusableElements = menu.querySelectorAll(
      'a[href], button, [tabindex]:not([tabindex="-1"])'
    );

    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    if (e.shiftKey) {
      // Shift + Tab
      if (document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable.focus();
      }
    } else {
      // Tab
      if (document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable.focus();
      }
    }
  }

  /**
   * Handle backdrop click
   */
  function handleBackdropClick(e) {
    // Close if clicking the backdrop (not the content)
    if (e.target === menu) {
      closeMenu();
    }
  }

  /**
   * Close menu when clicking internal links
   */
  function handleLinkClick(e) {
    if (!menuOpen) return;

    const link = e.target.closest('a[href]');
    if (!link) return;

    const href = link.getAttribute('href');

    // Close menu for internal links
    if (href && !href.startsWith('http') && !href.startsWith('#')) {
      closeMenu();
    }
  }

  // Expose methods globally
  window.Menu = {
    open: openMenu,
    close: closeMenu,
    toggle: toggleMenu,
    isOpen: () => menuOpen
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
